import React from "react";
import "./CoursePage.css";
import CccBanner from "../Component/banner3.jpg";

const CccPage = () => {
  return (
    <div className="course-page">
      {/* Banner Section */}
      <div className="course-banner">
        <img src={CccBanner} alt="CCC" className="banner-img" />
      </div>

      {/* Content Section */}
      <div className="course-content">
        <h2>CCC – Course on Computer Concepts</h2>

        <p className="course-text">
          The <strong>CCC (Course on Computer Concepts)</strong> is a foundational 
          course designed for individuals seeking to understand the basics of computer 
          usage. It is ideal for students, professionals, and government employees who 
          want to improve their computer literacy.
        </p>

        <p className="course-text">
          This program covers fundamental topics such as the introduction to computers, 
          operating systems, MS Office applications, internet usage, and digital payments. 
          Learners gain practical exposure to applications that are essential in modern 
          workplaces.
        </p>

        <p className="course-text">
          CPIT’s CCC training emphasizes practical, hands-on learning. Students practice 
          every concept in computer labs, ensuring that theory translates into real-world 
          ability and confidence.
        </p>

        <p className="course-text">
          The course aims to build self-reliance in using computers for official tasks, 
          online services, and digital communication. Participants become capable of handling 
          files, documents, emails, and online applications effectively.
        </p>

        <p className="course-text">
          On successful completion, learners receive a government-recognized certificate, 
          improving their employability in both private and public sectors. The program 
          also serves as a stepping stone toward advanced courses like <strong>ADCA</strong> 
          or <strong>O Level</strong>.
        </p>

        <p className="course-text mb-0">
          With CPIT’s expert mentorship, modern labs, and student-centered approach, the 
          CCC course builds the essential digital foundation needed for every career in 
          today’s technology-driven world.
        </p>
      </div>
    </div>
  );
};

export default CccPage;
